"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var markAsSeen = exports.markAsSeen = function markAsSeen(education, tooltipValue) {
  return education | tooltipValue;
};
var markAsUnseen = exports.markAsUnseen = function markAsUnseen(education, tooltipValue) {
  return ~tooltipValue & education;
};
var hasSeen = exports.hasSeen = function hasSeen(education, tooltipValue) {
  return tooltipValue === (education & tooltipValue);
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/popupPanel/tooltips/tooltipUtil.js
// module id = 1930
// module chunks = 0